import { TAO_KOE, Cookies } from './../libs';

const COOKIE_NAME = 'taoPLLPrefShop';

class LanguagePopup {
	constructor( popupEl ) {
		this.popupEl = popupEl;

		this.popupEl.addEventListener( 'click', ( ev ) => {
			if ( ev.target.closest( '.choose-lang' ) ) {
				ev.preventDefault();
				this.onChooseLang( ev.target );
			}
		} );

		this.popupEl.addEventListener( 'popup_closed.sl', () => {
			if ( ! this.popupEl.returnValue ) {
				const currentEl = this.popupEl.querySelector( '.choose-lang.current' );
				const country = currentEl.dataset.country;

				Cookies.set( COOKIE_NAME, country );
				this.popupEl.returnValue = country;
			}
		} );
	}

	open() {
		return TAO_KOE.open_popup( this.popupEl );
	}

	close = function( returnValue = '' ) {
		return TAO_KOE.close_popup( this.popupEl, returnValue );
	};

	onChooseLang( targetEl ) {
		const country = targetEl.dataset.country;
		Cookies.set( COOKIE_NAME, country );

		if ( targetEl.classList.contains( 'current' ) ) {
			// Stay on the current page.
			this.close( country );
		} else if ( targetEl.dataset.transferCookie ) {
			// Set CrossDomain Cookie so the Popup does not get displayed again.
			// Set Callback for after the fetch to always transfer to new domain.
			const transfer = () => {
				window.location.href = targetEl.getAttribute( 'href' );
			};

			const settings = {
				credentials: 'include',
				mode: 'no-cors',
			};

			// Get new cookie via fetch -> then transfer away.
			fetch( targetEl.dataset.transferCookie, settings ).then( transfer, transfer );
		} else {
			// When the transfer cookie is not needed, we just navigate to href.
			window.location.href = targetEl.getAttribute( 'href' );
		}
	}

	checkLanguage() {
		const current = document.documentElement.lang.slice( -2 ).toLowerCase();
		const cookie = Cookies.get( COOKIE_NAME );

		if ( ( cookie && cookie === current ) || window.EN_KO.functions.isMobileApp() ) {
			return Promise.resolve( current );
		}

		return fetch( '/cms/dispatch/popup/country/' ).then( ( response ) => {
			return response.json();
		} ).then( ( country ) => {
			TAO_KOE.console.log( country, current );

			if ( country === current.toUpperCase() ) {
				// Just resolve immediately.
				Cookies.set( COOKIE_NAME, current );
				return Promise.resolve( current );
			}

			// Open Popup and wait for it to resolve.
			return this.open();
		} );
	}
}

const initLanguagePopup = function( resolve ) {
	TAO_KOE.console.log( 'INIT LANGUAGE POPUP' );

	const popupEl = document.getElementById( 'popup_country_change' );
	if ( popupEl ) {
		popupEl.KOE_Language_Popup ??= new LanguagePopup( popupEl );
		popupEl.KOE_Language_Popup.checkLanguage().then( ( country ) => {
			TAO_KOE.console.log( 'RESOLVE LANGUAGE POPUP: ' + country );
			resolve();
		} );
	} else {
		resolve();
	}
};

// Init.
TAO_KOE.chainReady( 'language.js', initLanguagePopup, 5 );

// Expose.
TAO_KOE.LanguagePopup = LanguagePopup;

// Export.
export {
	LanguagePopup as default,
	initLanguagePopup,
};
